import { RootState, SessionTimeState } from '@/store';

export const getSessionTime = (state: RootState): SessionTimeState => state.sessionTime;
